var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smallModal',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.lang['CreateNewCompany'])+"?")]),_c('hr'),_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.cansel}},[_vm._v(_vm._s(_vm.lang['Сancel']))]),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.yes}},[_vm._v(_vm._s(_vm.lang['Yes']))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }